var map = {
	"./almost.gif": "./gif/almost.gif",
	"./correct-1.gif": "./gif/correct-1.gif",
	"./correct-2.gif": "./gif/correct-2.gif",
	"./correct-3.gif": "./gif/correct-3.gif",
	"./correct-4.gif": "./gif/correct-4.gif",
	"./correct-5.gif": "./gif/correct-5.gif",
	"./correct-6.gif": "./gif/correct-6.gif",
	"./correct-7.gif": "./gif/correct-7.gif",
	"./correct-8.gif": "./gif/correct-8.gif",
	"./correct-9.gif": "./gif/correct-9.gif",
	"./wrong-1.gif": "./gif/wrong-1.gif",
	"./wrong-2.gif": "./gif/wrong-2.gif",
	"./wrong-3.gif": "./gif/wrong-3.gif",
	"./wrong-4.gif": "./gif/wrong-4.gif",
	"./wrong-5.gif": "./gif/wrong-5.gif",
	"./wrong-6.gif": "./gif/wrong-6.gif",
	"./wrong-7.gif": "./gif/wrong-7.gif",
	"./wrong-8.gif": "./gif/wrong-8.gif",
	"./wrong-9.gif": "./gif/wrong-9.gif"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./gif sync recursive \\.gif$";